module.exports = __webpack_public_path__ + "static/img/item9.6c2aaa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/item9.png
// module id = 7eag
// module chunks = 0